module.exports = __webpack_public_path__ + "media/images/products/wedding/img-feature-initial-cf030229b308359b7e4b0c981d080c5d.png";